import { convertMBToBytes } from '../utils/files'

export const userImageMaxSize = 5 // mb
export const userImageMaxSizeInBytes = convertMBToBytes(userImageMaxSize)

export const userImageMaxWidth = 1920 //px
export const userImageMaxHeight = userImageMaxWidth

export const defaultResetDurationInSeconds = 60
